/**
 * ファイルアップロード可能な最大バイト数
 * - 一旦 500メガバイトで設定
 */
export const MAX_UPLOAD_FILE_SIZE = 524288000
